import React from 'react';
import { IonCard, IonCardContent, IonIcon } from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';

/** Placeholder shown when a topic doesn't exist, is private, or was removed. */
const NotFoundCard: React.FC = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <IonCard color="danger">
      <IonCardContent>
        <IonIcon icon={alertCircleOutline} size="large" />
        <h2>Topic Not Found</h2>
        <p>
          The topic you're looking for doesn't exist or is private or removed.
        </p>
      </IonCardContent>
    </IonCard>
  </div>
);

export default NotFoundCard;
